import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import Flag from "react-world-flags";

export interface Currency {
  id: number;
  code: string;
  name: string;
  symbol: string;
  flag: string;
}

interface CurrencyAmountInputProps {
  currencies: Currency[];
  currencyValue: string;
  amountValue: number | string;
  onCurrencyChange: (event: any) => void;
  onAmountChange: (event: any) => void;
  currencyError?: boolean;
  currencyHelperText?: string | false | undefined;
  amountError?: boolean;
  amountHelperText?: string | false | undefined;
}

const CurrencyAmountInput = ({
  currencies,
  currencyValue,
  amountValue,
  onCurrencyChange,
  onAmountChange,
  currencyError,
  currencyHelperText,
  amountError,
  amountHelperText,
}: CurrencyAmountInputProps) => {
  const selectedCurrency = currencies.find((c) => c.code === currencyValue);
  return (
    <>
      <Grid item xs={12}>
        <Stack spacing={1}>
          <InputLabel htmlFor="currency">Currency</InputLabel>
          <FormControl fullWidth error={currencyError}>
            <Select
              id="currency"
              name="currency"
              value={currencyValue}
              onChange={onCurrencyChange}
              displayEmpty
              renderValue={(selected) => {
                const curr = currencies.find((c) => c.code === selected);
                if (!curr) return "Select Currency";

                return (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 22,
                        height: 14,
                        overflow: "hidden",
                        borderRadius: "2px",
                        flexShrink: 0,
                      }}
                    >
                      <Flag code={curr.flag} />
                    </Box>

                    <span>{curr.code}</span>
                    <span style={{ color: "#888" }}>{curr.symbol}</span>
                  </Box>
                );
              }}
            >
              {currencies.map((currency) => (
                <MenuItem
                  key={currency.code}
                  value={currency.code}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Box
                    sx={{
                      width: 22,
                      height: 14,
                      overflow: "hidden",
                      borderRadius: "2px",
                      flexShrink: 0,
                    }}
                  >
                    <Flag code={currency.flag} />
                  </Box>

                  <Box flexGrow={1}>{currency.name}</Box>

                  <Box color="text.secondary">
                    {currency.code} — {currency.symbol}
                  </Box>
                </MenuItem>
              ))}
            </Select>
            {currencyError && (
              <FormHelperText error>{currencyHelperText}</FormHelperText>
            )}
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={1}>
          <InputLabel htmlFor="amount">Amount</InputLabel>
          <TextField
            fullWidth
            id="amount"
            name="amount"
            placeholder="Enter Amount"
            type="number"
            value={amountValue}
            onChange={onAmountChange}
            error={amountError}
            helperText={amountHelperText}
            inputProps={{ min: 0, step: "0.01" }}
            InputProps={{
              startAdornment: selectedCurrency ? (
                <InputAdornment position="start">
                  {selectedCurrency.symbol}
                </InputAdornment>
              ) : undefined,
            }}
          />
        </Stack>
      </Grid>
    </>
  );
};

export default CurrencyAmountInput;
